import { ReactNode, useEffect, useState } from "react";
import styles from "./style.module.scss";
import DynamicForm from "@mavichpe/dynamic-forms";
import BarcodeFormFormConfig from "./form";
import PrintableTag from "./components/PrintableTag";
import { CurrencyApi } from "@/api/CurrencyApi";
import { CurrencyIdPubSub } from "@utils/pubsubs/PubSub";
import { useAppDispatch } from "@/store/hooks";
import { setCurrency } from "@/store/slices/currencySlides";
import cx from "classnames";

type BarcodeGeneratorFormProps = {
}

type BarcodeFormDataType = {
  barcodeFormat: string
}

const BarcodeGeneratorForm = (props: BarcodeGeneratorFormProps) => {
  const [format, setFormat] = useState<string>("");
  const [lines, setLines] = useState<number>(0);
  const dispatch = useAppDispatch()

  useEffect(() => {
    import("./print-tags.scss");
    setDefaultPrice()
  }, []);

  useEffect(() => {
    if (format == "3") {
      setLines(50);
    }
  }, [format]);

  const setDefaultPrice = async () => {
    const defaultCurrency = await CurrencyApi.getDefaultCurrency()
    if (defaultCurrency.id) {
      CurrencyIdPubSub.publish({ currencyId: defaultCurrency.id })
      dispatch(setCurrency(defaultCurrency))
    }

  }

  const onInputChange = (name: keyof BarcodeFormDataType, value: any, event?: React.ChangeEvent<any>) => {
    if (name == "barcodeFormat") {
      setFormat(`${value}`)
    }
  }

  const generatePrintableTags = (): ReactNode[] => {
    return Array(lines).fill(null).map(() => {
      return (<PrintableTag></PrintableTag>)
    })
  }

  return (
    < >
      <DynamicForm<BarcodeFormDataType>
        formConfig={BarcodeFormFormConfig}
        onInputChange={onInputChange}
      />

      <div className={cx(["printableArea", styles.tagContainer])}>
        {lines > 0 && generatePrintableTags()}

      </div >
    </>
  );
}

export default BarcodeGeneratorForm;
